import React from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/PageHeader';
import { useData } from '../context/DataContext';
import { Sparkles, Info } from 'lucide-react';
import Translate from '../components/Translate';

const OurStrengths = () => {
  const { data, loading } = useData();

  // Pure Firestore Data - Only save data added by admin
  const strengths = data.strengths || [];

  if (loading) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center bg-ivory">
        <div className="w-10 h-10 border-4 border-emerald border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ivory pb-28 font-poppins">
      <PageHeader
        title={<Translate>Our Strengths & Vision</Translate>}
        subtitle={<Translate>Discover the core pillars, modern infrastructure, and operational excellence that drive our success.</Translate>}
      />

      {/* Main Strengths Section */}
      <section className="pt-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        


        {/* Strengths Cards Grid - Single row align 3 cards on desktop */}
        {strengths.length === 0 ? (
          <div className="py-20 text-center bg-white rounded-3xl border border-gray-100 shadow-premium max-w-md mx-auto">
            <div className="w-12 h-12 bg-emerald/10 text-emerald rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Info size={24} />
            </div>
            <h4 className="text-lg font-heading font-bold text-charcoal mb-2">
              <Translate>No Strengths Added Yet</Translate>
            </h4>
            <p className="text-xs text-slate px-6">
              <Translate>Strengths added by the admin will appear here.</Translate>
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {strengths.map((item, idx) => (
              <motion.div
                key={item.id || idx}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                className="group bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col h-full"
              >
                {/* Image Container */}
                <div className="relative h-60 overflow-hidden bg-gray-100">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400">
                      <Sparkles className="w-12 h-12 stroke-1" />
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Card Title */}
                <div className="p-6 flex-grow flex items-center bg-white">
                  <h3 className="text-sm sm:text-base font-heading font-semibold text-charcoal group-hover:text-emerald transition-colors duration-300 text-left leading-relaxed w-full">
                    <Translate>{item.title}</Translate>
                  </h3>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default OurStrengths;
